export const IMAGES = {
    fableticsLogo: '/img/v3/graphics/perks/fabletics/fabletics-logo.png',
    gpLogo: '/img/v3/graphics/perks/global-privileges/global-privileges-logo.png',
    powerIcon: '/img/v3/icons/icon-utr-logo-black.svg',
    airport: '/img/v3/graphics/perks/global-privileges/tennis-passport.png',
    tennisWomen: '/img/v3/graphics/perks/fabletics/fabletics-women.png',
    powerHeroDesktop: '/img/v3/graphics/perks/fabletics/power-card-hero-desktop.png',
    powerHeroMobile: '/img/v3/graphics/perks/fabletics/power-card-hero-mobile.png',
};

export const COPY = {
    fableticsCard: '$1000+ in free membership, VIP prices (up to 50% off), quarterly rewards, & more.',
    gpCard: '$250+ value in travel benefits, incl. $100 voucher and up to 60% off on 1.4M+ hotels.',
    powerCard: '2 Decimal ratings, in-depth performance analytics, discounted entry fees, & more.',
    monthlyHeadline: 'Upgrade to annual Power and get two free memberships worth $1250+ in value.',
    dualHeadlineTitle: 'Play. Stay. Style.',
    dualHeadlineValue: '$1,450+ in value',
};
